import React, { useEffect } from 'react';

export const Disclaimer = () => {
  return (
    <>
      <p>
        The information presented here only reflects changes made to your
        company's master eligibility file and processed through the Electronic
        Eligibility Management System. It does not reflect changes made through
        other sources (e.g., EmployereServices.com, paper eligibility forms,
        customer service requests). Please remember to always update your
        eligibility source system.
      </p>
      <br />
      <p>
        You may view your current eligibility information online at
        www.EmployereServices.com.
      </p>
    </>
  );
};
